<template>
  <span>{{formatString}}</span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TimeFormatter',
  props: {
    time: [Object, String, Date],
    format: String,
  },
  data() {
    return {
      formatString: '',
    };
  },
  watch: {
    time(val) {
      this.formatString = moment(val).locale('zh-cn')
        .format(this.format);
    },
    format(val) {
      this.formatString = moment(this.time).locale('zh-cn')
        .format(val);
    },
  },
  created() {
    this.formatString = moment(this.time).locale('zh-cn')
      .format(this.format);
  },
};
</script>

<style scoped>

</style>
